import { a } from './chunk-TWGPE4V7.js';
import { cx } from '@onbeam/styled-system/css';
import { card, noiseBackground } from '@onbeam/styled-system/recipes';
import { jsxs, jsx } from 'react/jsx-runtime';

var i=a(({as:s="div",children:t,size:m="md",className:p,...c},h)=>{let a=card({size:m});return jsxs(s,{ref:h,className:cx(a.root,p),...c,children:[jsxs("div",{"aria-hidden":!0,className:cx(noiseBackground(),a.edgeShadows),children:[jsx("div",{"aria-hidden":!0,className:cx(a.edgeShadow,a.edgeShadowHorizontal)}),jsx("div",{"aria-hidden":!0,className:cx(a.edgeShadow,a.edgeShadowVertical,a.edgeShadowVerticalLeft)}),jsx("div",{"aria-hidden":!0,className:cx(a.edgeShadow,a.edgeShadowVertical,a.edgeShadowVerticalRight)})]}),t]})});i.displayName="Card";

export { i as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-2PAFMHQ4.js.map